import React from "react";
import "./ui.css";

// Shimmering placeholder rows shown in place of <LoadingState/>'s spinner
// while a table's data is loading -- keeps the header/column shape in
// place instead of collapsing to a centered spinner, which is closer to
// how the row content will actually land once it arrives.
export default function TableSkeleton({ columns, rows = 5 }) {
  return (
    <table className="ui-table ui-table-skeleton" aria-hidden="true">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key} className={col.align === "center" ? "ui-th-center" : ""} style={col.minWidth ? { minWidth: col.minWidth } : undefined}>
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((col) => (
              <td key={col.key}>
                <span className="ui-skeleton-bar" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
